import type { BrandTwoLetterCode } from "brandRegionConfig";

const SubDomainMap = new Map<string, BrandTwoLetterCode>([
  ["portal-cre", "CR"],
  ["portal-fixauto", "FA"],
  ["portal-novusglass", "NG"],
  ["portal-procolor", "PC"],
  ["portal-speedy", "SA"],
  ["portal-speedyauto", "SA"],
  ["portal-speedyglass", "SG"],
  ["portal-collisionrepairexperts", "CR"],
  ["portal-novuscrystalglass", "NC"],
  ["portal-fixnationrestoration", "NR"],
]);

export default SubDomainMap;
